// eslint-disable-next-line import/named
import { type IntlShape } from 'react-intl';

export const labelsStepIndicator = (intl: IntlShape) => {
  return [
    intl.formatMessage({
      id: 'c8.header.vehicle'
    }),
    intl.formatMessage({
      id: 'c8.header.services'
    }),
    intl.formatMessage({
      id: 'c8.header.transportation'
    }),
    intl.formatMessage({
      id: 'c8.common.appointment',
      // TODO: remove default message once localization string is ready
      defaultMessage: 'Appointment'
    })
  ];
};

export const labelsStepIndicatorSCI = (intl: IntlShape) => {
  // TODO: remove default messages once localization string is ready
  return [
    intl.formatMessage({ id: 'c8.self.check.in.header.mileage' }),
    intl.formatMessage({ id: 'c8.self.check.in.header.services' }),
    intl.formatMessage({
      id: 'c8.self.check.in.header.advisor',
      defaultMessage: 'Advisor'
    }),
    intl.formatMessage({
      id: 'c8.self.check.in.header.signature',
      defaultMessage: 'Signature'
    })
  ];
};



// WEBPACK FOOTER //
// ./src/constants/CTAConfig.js